(function () {

    angular
        .module('ngmvac')
        .factory('DestinyFactory', DestinyFactory);

    DestinyFactory.$inject = ['$window', '$http', 'DatosCotizador', '$q'];

    function DestinyFactory($window, $http, DatosCotizador, $q) {

        return {
            get_: get_,
            getDestinationsByCountry: getDestinationsByCountry,
            getCountries: getCountries,
            getHotelsFromDB: getHotelsFromDB
        }

        function get_(params) {
            return $http.post('/get_hotels_by_destiny', {
                params: params
            });
        }

        function getDestinationsByCountry() {
            return $http.get('/get_destinations_by_country');
        }

        function getCountries() {
            return $http.get('/get_countries');
        }

        function getHotelsFromDB() {
            return $http.get('/get_hotels_from_db');
        }
    }

})();